<template>
      <div>
            <div class="flex xs-12 xs-middle mb2" v-for="(item, index) in value" :key="index">
                  <!-- Input -->
                  <j-base-input-text
                        class="xs-10"
                        :value="item.stringValue"
                        placeholder="List Item"
                        @input="onInput()"
                        v-model="item.stringValue"
                  />
                  <!-- Remove Button -->
                  <j-button
                        class="ml4"
                        type="error"
                        size="xsmall"
                        @click="removeFromList(index)"
                  >{{ $t("remove") }}</j-button>
            </div>
            <div class="flex xs-12 xs-right">
                  <!-- Add Button -->
                  <j-button class="mr1" type="secondary" @click="addToList" size="xsmall">{{ $t("add_row") }}</j-button>
            </div>
      </div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText/"
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"

export default {
	name: "j-input-list",

	props: {
		value: {
			default: () => [{ stringValue: null }]
		}
	},

	components: {
		JBaseInputText,
		CrmIcon,
		JButton
	},

	methods: {
		//Add new object to List type
		addToList() {
			this.value.push({ stringValue: null })
		},

		//Remove selected object of List type
		removeFromList(index) {
			if (this.value.length > 1) this.value.splice(index, 1)
			else this.value[0].stringValue = null
		},

		onInput() {
			this.$emit("input", this.value)
		}
	}
}
</script>
